import { observable, computed, action } from 'mobx';
import CashFormStore, {
  ICashFormStoreAttributes,
} from '../../domain/entities/CashFormStore/CashFormStore';

interface ICashFormViewControllerConfig {
  cashFormStore: CashFormStore;
}

export default class CashFormViewController {
  @observable cashFormStore: CashFormStore;

  constructor(config: ICashFormViewControllerConfig) {
    this.cashFormStore = config.cashFormStore;
  }

  loaded = async (): Promise<void> => {
    this.cashFormStore.clearStore();
  };

  @action
  onCashTypeChange = (cashType: string): void => {
    this.cashFormStore.updateCashValues({ cashType });
  };

  @computed
  get data(): ICashFormStoreAttributes {
    return this.cashFormStore.values;
  }
}
